import { createRoot } from "react-dom/client";
import App from "./App";
import "./styles/tokens.css";
import "./styles/base.css";

const container = document.getElementById("root");
if (!container) {
  // 不会发生（index.html 固定有 #root），但显式报错比静默白屏好排查
  throw new Error("缺少挂载节点 #root");
}

const root = createRoot(container, {
  // React 19：捕获未被错误边界处理的渲染错误，输出完整堆栈便于定位
  onUncaughtError: (error, info) => {
    console.error("[react-uncaught]", error, info?.componentStack);
  },
  onCaughtError: (error, info) => {
    console.error("[react-caught]", error, info?.componentStack);
  },
});

root.render(<App />);
